<template>
  <apexcharts height="250" :options="chartOptions" :series="series" />
</template>

<script>
import apexcharts from 'vue-apexcharts';

export default {
	components: {
		apexcharts,
	},
	// eslint-disable-next-line vue/require-prop-types
	props: ['series', 'interval'],
	data() {
		return {
			notregistered: {
				name: 'Cadastros não Concretizados',
				data: [0, 0, 0, 0, 0, 0, 0],
			},
			registered: {
				name: 'Cadastros',
				data: [0, 0, 0, 0, 0, 0, 0],
			},

			pending: {
				name: 'Receberam Link',
				data: [0, 0, 0, 0, 0, 0, 0],
			},
			chartOptions: {
				chart: {
					type: 'line',
					zoom: {
						enabled: false,
					},
					toolbar: {
						show: false,
					},
					lines: {
						show: false,
					},
				},
				dataLabels: {
					enabled: false,
				},
				stroke: {
					curve: 'smooth',
					width: 3,
				},
				xaxis: {
					labels: {
						show: true,
					},
					/* categories: this.interval, */
					axisBorder: {
						show: false,
						color: '#fff',
						height: 6,
						width: '100%',
						offsetX: 0,
						offsetY: 0,
					},
				},
				yaxis: {
					labels: {
						show: false,
					},
				},
				legend: {
					show: false,
				},

				grid: {
					show: false,
				},
				tooltip: {
					enabledOnSeries: false,
					shared: true,
					intersect: false,
					marker: {
						show: true,
					},
					x: {
						show: true,
					},
					y: {
						show: false,
					},
				},
			},
		};
	},
	computed: {
		cadastro() {
			return [this.registered, this.pending, this.notregistered];
		},
	},
};
</script>

<style></style>
